import { render, staticRenderFns } from "./AllReports.vue?vue&type=template&id=51991b79&scoped=true&"
import script from "./AllReports.vue?vue&type=script&lang=js&"
export * from "./AllReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51991b79",
  null
  
)

export default component.exports